/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "ProvisionApplePayRequest": {
                "fields": {
                  "certificates": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "nonce": {
                    "type": "bytes",
                    "id": 2,
                    "rule": "optional"
                  },
                  "nonceSignature": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ProvisionApplePayResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.corporate_card.service.ProvisionApplePayResponse.Success",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {
                      "encryptedPassData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "activationData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "ephemeralPublicKey": {
                        "type": "bytes",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ProvisionApplePayRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ProvisionApplePayResponse && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ProvisionApplePayResponse?.nested?.Success) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ProvisionApplePayRequest @ squareup/corporate_card/service/provision_apple_pay.proto at 10:1
 */
export const ProvisionApplePayRequest = $root.lookupType('squareup.corporate_card.service.ProvisionApplePayRequest');
fixType(ProvisionApplePayRequest, {
  cardToken: {
    required: true
  },
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(ProvisionApplePayRequest);
/**
 * SOURCE ProvisionApplePayResponse @ squareup/corporate_card/service/provision_apple_pay.proto at 23:1
 */
export const ProvisionApplePayResponse = $root.lookupType('squareup.corporate_card.service.ProvisionApplePayResponse');
fixType(ProvisionApplePayResponse);
Builder.createAndAttachToType(ProvisionApplePayResponse);
/**
 * SOURCE Success @ squareup/corporate_card/service/provision_apple_pay.proto at 24:3
 */
ProvisionApplePayResponse.Success = $root.lookupType('squareup.corporate_card.service.ProvisionApplePayResponse.Success');
fixType(ProvisionApplePayResponse.Success);
Builder.createAndAttachToType(ProvisionApplePayResponse.Success);